import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { HintModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class HintsRepository {
  constructor(private apiService: ApiService) {}

  public search(): Observable<HintModel[]> {
    return this.apiService.get<HintModel[]>(`${environment.url.prefixCustoms}v2/hints`);
  }
}
